"use client";

import { useEffect } from "react";

export function FestivalHome() {
  useEffect(() => { document.title = "文化祭｜ホーム"; }, []);
  return (
    <main className="public-shell">
      <header className="topbar">
        <a className="brand" href="/" aria-label="文化祭ホーム">
          <span className="brand-mark">文</span>
          <span>文化祭 <small>QUEUE PASS</small></span>
        </a>
        <nav className="public-nav" aria-label="メインメニュー">
          <a href="/" aria-current="page">ホーム</a>
          <a className="nav-reserve" href="/reserve">予約する <span>→</span></a>
          <a href="/admin">スタッフ入口</a>
        </nav>
      </header>

      <section className="hero" id="top">
        <div className="hero-copy">
          <p className="eyebrow"><span>✦</span> ENJOY WITHOUT THE WAIT</p>
          <h1>並ぶ時間を、<br /><em>楽しむ時間</em>に。</h1>
          <p className="hero-lead">気になるクラス企画の順番をスマホで予約。<br />あなたの番まで、文化祭をもっと楽しもう。</p>
          <a className="primary-button" href="/reserve">予約ページへ <span>→</span></a>
        </div>
        <div className="hero-art" aria-hidden="true">
          <div className="sunburst" />
          <div className="ticket-shape">
            <span className="ticket-mini">CULTURE FESTIVAL</span>
            <strong>QUEUE<br />PASS</strong>
            <span className="fake-qr">▦</span>
          </div>
          <span className="doodle doodle-one">✦</span>
          <span className="doodle doodle-two">◎</span>
          <span className="doodle doodle-three">♪</span>
        </div>
      </section>

      <section className="howto-strip" aria-label="予約の使い方">
        <div><b>01</b><span>企画を選ぶ</span></div>
        <i>→</i>
        <div><b>02</b><span>順番を予約</span></div>
        <i>→</i>
        <div><b>03</b><span>QRで受付</span></div>
      </section>

      <section className="home-guide">
        <div className="home-guide-copy">
          <p className="eyebrow"><span>●</span> HOW IT WORKS</p>
          <h2>予約して、<br />自由にめぐろう。</h2>
          <p>予約に必要なのはお名前だけ。次の順番を取ることも、希望時刻の枠を確保することもできます。発行されたQR予約券をスクリーンショットして、企画の受付で見せてください。</p>
          <a className="primary-button" href="/reserve">クラス企画を見る <span>→</span></a>
        </div>
        <div className="home-guide-cards">
          <article><b>01</b><span>CHOOSE</span><h3>企画を探す</h3><p>クラス名や企画名から、行きたいアトラクションを選びます。</p></article>
          <article><b>02</b><span>RESERVE</span><h3>順番・時刻を予約</h3><p>現在の列の最後、または空いている希望時刻を予約できます。</p></article>
          <article><b>03</b><span>CHECK IN</span><h3>QRで受付</h3><p>保存した予約券を企画スタッフに見せれば受付完了です。</p></article>
        </div>
      </section>

      <section className="home-final-cta">
        <span aria-hidden="true">✦</span>
        <div><p>READY TO EXPLORE?</p><h2>文化祭を、もっと楽しもう。</h2></div>
        <a href="/reserve">予約をはじめる <b>→</b></a>
      </section>

      <footer><div className="brand"><span className="brand-mark">文</span><span>文化祭</span></div><p>名前だけで予約できます。予約券は忘れずに保存してください。</p><a href="/admin">スタッフ入口</a></footer>
    </main>
  );
}
